<div class="sidebar-wrapper">
  <!-- Mobile Close Button -->
  @if (isMobileView) {
    <div class="mobile-close-container">
      <button class="mobile-close-btn" (click)="closeMobileSidebar.emit()" aria-label="Close sidebar">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  }

  <!-- Header Section -->
  <div class="sidebar-header">
    <div class="logo-section">
      <img src="../../assets/img/hc-logo-clean.png" alt="Logo" class="logo-img" style="width: 40px; height: 40px;" />
      <div class="brand-info">
        <span class="brand-title">HarperCollins AI</span>
        <span class="brand-subtitle">Multi-Modal Chatbot</span>
      </div>
    </div>
  </div>

  <!-- New Chat Button -->
  <button class="new-chat-btn btn-outline-primary" (click)="startNewChat()">
    <i class="bi bi-plus-lg"></i>
    <span>New Chat</span>
  </button>

  <!-- Divider -->
  <div class="section-divider"></div>

  <!-- Search Box -->
  <div class="search-container">
    <i class="bi bi-search search-icon"></i>
    <input type="text" class="search-input" placeholder="Search chats..." [(ngModel)]="searchTerm">
  </div>

  <!-- Chat Sessions List -->
  <div class="sessions-list">
    <!-- Pinned Sessions Section -->
    @if (pinnedSessions.length > 0) {
      <div class="pinned-section">
        <div class="section-label">
          <i class="bi bi-pin-angle-fill"></i>
          <span>Pinned</span>
        </div>
        @for (session of pinnedSessions; track session) {
          <a href="#" class="session-item pinned"
            [class.active]="currentSessionId === session.id" (click)="loadSession(session.id)">
            <i class="bi bi-pin-fill pin-indicator"></i>
            @if (editingSessionId !== session.id) {
              <span class="session-name" [title]="session.name || session.title">
                {{ session.name || session.title }}
              </span>
            }
            @if (!isSessionModelAvailable(session) && editingSessionId !== session.id) {
              <span class="model-badge">Model
              Unavailable</span>
            }
            <!-- 3-dot menu button -->
            @if (editingSessionId !== session.id) {
              <div class="session-menu-wrapper">
                <button class="menu-btn"
                  (click)="$event.preventDefault(); $event.stopPropagation(); toggleSessionMenu(session.id, $event)"
                  title="More options">
                  <i class="bi bi-three-dots"></i>
                </button>
                <!-- Dropdown Menu -->
                <div class="session-dropdown"
                  [class.active]="openMenuSessionId === session.id"
                  [style.top.px]="sessionDropdownTop"
                  [style.left.px]="sessionDropdownLeft">
                  <button class="dropdown-item" (click)="$event.stopPropagation(); startEditTitle(session, $event)">
                    <i class="bi bi-pencil"></i>
                    <span>Rename</span>
                  </button>
                  <button class="dropdown-item" (click)="$event.stopPropagation(); togglePinSession(session, $event)">
                    <i class="bi bi-pin-angle"></i>
                    <span>Unpin chat</span>
                  </button>
                  <button class="dropdown-item delete" (click)="$event.stopPropagation(); deleteSession(session.id)">
                    <i class="bi bi-trash"></i>
                    <span>Delete</span>
                  </button>
                </div>
              </div>
            }
            @if (editingSessionId === session.id) {
              <div class="edit-mode" (click)="$event.stopPropagation()">
                <input type="text" class="edit-input" [(ngModel)]="editedTitle"
                  (keydown.enter)="saveEditedTitle(session, $event)" (keydown.escape)="cancelEditTitle($event)"
                  placeholder="Enter title" />
                <button class="action-btn save-btn" title="Save" (click)="saveEditedTitle(session, $event)">
                  <i class="bi bi-check"></i>
                </button>
                <button class="action-btn cancel-btn" title="Cancel" (click)="cancelEditTitle($event)">
                  <i class="bi bi-x"></i>
                </button>
              </div>
            }
          </a>
        }
      </div>
    }

    <!-- Regular Sessions Section -->
    <div class="regular-section">
      @for (session of unpinnedSessions; track session) {
        <a href="#" class="session-item"
          [class.active]="currentSessionId === session.id" (click)="loadSession(session.id)">
          @if (editingSessionId !== session.id) {
            <span class="session-name" [title]="session.name || session.title">
              {{ session.name || session.title }}
            </span>
          }
          @if (!isSessionModelAvailable(session) && editingSessionId !== session.id) {
            <span class="model-badge">Model
            Unavailable</span>
          }
          <!-- 3-dot menu button -->
          @if (editingSessionId !== session.id) {
            <div class="session-menu-wrapper">
              <button class="menu-btn"
                (click)="$event.preventDefault(); $event.stopPropagation(); toggleSessionMenu(session.id, $event)"
                title="More options">
                <i class="bi bi-three-dots"></i>
              </button>
              <!-- Dropdown Menu -->
              <div class="session-dropdown"
                [class.active]="openMenuSessionId === session.id"
                [style.top.px]="sessionDropdownTop"
                [style.left.px]="sessionDropdownLeft">
                <button class="dropdown-item" (click)="$event.stopPropagation(); startEditTitle(session, $event)">
                  <i class="bi bi-pencil"></i>
                  <span>Rename</span>
                </button>
                <button class="dropdown-item" (click)="$event.stopPropagation(); togglePinSession(session, $event)">
                  <i class="bi bi-pin-angle"></i>
                  <span>Pin chat</span>
                </button>
                <button class="dropdown-item delete" (click)="$event.stopPropagation(); deleteSession(session.id)">
                  <i class="bi bi-trash"></i>
                  <span>Delete</span>
                </button>
              </div>
            </div>
          }
          @if (editingSessionId === session.id) {
            <div class="edit-mode" (click)="$event.stopPropagation()">
              <input type="text" class="edit-input" [(ngModel)]="editedTitle"
                (keydown.enter)="saveEditedTitle(session, $event)" (keydown.escape)="cancelEditTitle($event)"
                placeholder="Enter title" />
              <button class="action-btn save-btn" title="Save" (click)="saveEditedTitle(session, $event)">
                <i class="bi bi-check"></i>
              </button>
              <button class="action-btn cancel-btn" title="Cancel" (click)="cancelEditTitle($event)">
                <i class="bi bi-x"></i>
              </button>
            </div>
          }
        </a>
      }
    </div>

    @if (isLoadingSessions) {
      <div class="sessions-loading">
        <span class="loading-spinner"></span>
        <span>Loading chats...</span>
      </div>
    } @else if (filteredChatSessions.length === 0) {
      <p class="empty-state">
        No chat sessions found.
      </p>
    }
  </div>

  <!-- LLM Controls Section -->
  <div class="sidebar-controls">
    <!-- Header -->
    <div class="creativity-header">
      <span class="creativity-label">Models</span>
    </div>
    <!-- <div class="controls-header">
    <span>LLM Models</span>
  </div> -->

  <!-- LLM Models Hover Menu -->
  <div class="control-group">
    <div class="sidebar-menu-item" #modelMenuItem (mouseenter)="onModelMenuHover($event)"
      (mouseleave)="onModelMenuLeave()">
      <div class="menu-item-label">
        <!-- <i class="bi bi-cpu"></i> -->
        <span>{{ getCurrentModelName() }}</span>
      </div>
      <i class="bi bi-chevron-right menu-arrow"></i>

      <!-- Model List - Shows on right on hover -->
      <div class="model-submenu" #modelSubmenu (mouseenter)="onSubmenuHover()" (mouseleave)="onModelMenuLeave()">
        @for (model of availableModels; track model) {
          <div class="model-submenu-item"
            [class.active]="selectedModel === model.slug" (click)="selectedModel = model.slug; onModelChange()">
            <span>{{ model.name }}</span>
            @if (selectedModel === model.slug) {
              <i class="bi bi-check-circle-fill"></i>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Creativity Slider -->
  @if (selectedModel !== 'gpt-5-mini') {
    <div class="control-group">
      <div class="creativity-header">
        <span class="creativity-label">Creativity</span>
      </div>
      <div class="slider-wrapper">
        <input type="range" class="creativity-slider" min="0" max="1" step="0.5" [(ngModel)]="creativityValue"
          (change)="onCreativityChange()">
        <div class="slider-labels">
          <span class="slider-min" [class.active]="creativityValue === 0">low</span>
          <span class="slider-middle" [class.active]="creativityValue === 0.5">medium</span>
          <span class="slider-max" [class.active]="creativityValue === 1">high</span>
        </div>
      </div>
    </div>
  }

  <!-- Reasoning Level (for GPT-5 Mini) - Slider Design -->
  @if (selectedModel === 'gpt-5-mini') {
    <div class="control-group">
      <div class="creativity-header">
        <span class="creativity-label">Reasoning</span>
      </div>
      <div class="slider-wrapper">
        <input type="range" class="creativity-slider" min="0" max="1" step="0.5" [(ngModel)]="reasoningValue"
          (change)="onReasoningValueChange()">
        <div class="slider-labels">
          <span class="slider-min" [class.active]="reasoningValue === 0">low</span>
          <span class="slider-middle" [class.active]="reasoningValue === 0.5">medium</span>
          <span class="slider-max" [class.active]="reasoningValue === 1">high</span>
        </div>
      </div>
    </div>
  }

  <!-- Reasoning Level (for Gemini 2.5 Pro) - Slider Design -->
  @if (isGemini25Pro()) {
    <div class="control-group">
      <div class="creativity-header">
        <span class="creativity-label">Reasoning</span>
      </div>
      <div class="slider-wrapper">
        <input type="range" class="creativity-slider" min="0" max="1" step="0.5" [value]="getReasoningValue()"
          (input)="onReasoningSliderChange(+$any($event.target).value)">
        <div class="slider-labels">
          <span class="slider-min" [class.active]="getReasoningValue() === 0">low</span>
          <span class="slider-middle" [class.active]="getReasoningValue() === 0.5">medium</span>
          <span class="slider-max" [class.active]="getReasoningValue() === 1">high</span>
        </div>
      </div>
    </div>
  }
</div>
</div>